export const LocationDetailConstants = {
    locationTypes: {
        dropOff: 'DropOff',
        pickUp: 'Pickup',
        rescue: 'Rescue',
        other: 'Other',
    },
    newLocation: {
        locationId: 0,
        locationType: 'DropOff',
        streetAddress: '',
        city: '',
        state: '',
        zipCode: '',
        country: '',
        latitude: 0,
        longitude: 0,
        instructions: '',
        completeAddress: '',
        timeZone: '',
    },
    oneKmInMile: 0.621371,
    markUp: 1.03,
    oneKilometer: 1000,
};

export const ShipmentTitles = [
    'Date',
    'Pick-Up',
    'Drop-Off',
    'Commodity',
    'Weight/Hd Ct',
    'Miles',
    'Rate Type',
    'Rate',
];

export const ADD_LOCATION_MODAL_MAP_ZOOM = 9;

export const LoadTypeConstants = {
    _49k: '49k:',
    _52k: '52k:',
    _55_62k: '55-62k:',
    _68k: '68k:',
    _10500Gas: '10,500 Gas:',
    _9800Diesel: '9,800 Diesel:',
    _9800Gas: '9,800 Gas:',
    _9300DF: '9,300 DF:',
};

export const BuildShipmentTabConstants = {
    customerDetail: 'customerDetail',
    shipmentDetail: 'shipmentDetail',
    orderDetails: 'orderDetails',
};

export const BuildShipmentStatusConstants = {
    ContinueBuilding: 'ContinueBuilding',
    needDriver: 'NeedsDrivers',
};

export const BuildOrderStatusConstants = {
    Unassigned: 'UNASSIGNED',
    Drafted: 'DRAFTED',
    AttachedToShipment: 'ATTACHED_TO_SHIPMENT',
};

export const CommodityDropdownKey = 'create_commodity';

export const AddLocationModalConstants = {
    modalTitle: 'BS_AddLocationModal:modalTitle',
    modalType: 'AddLocation',
};

export const SYNTHETIC_BASE = 1000000;

export const DATE_FORMAT = 'YYYY-MM-DD';

export const MAX_COORDINATE_DECIMAL_PRECISION = 10;
